/**
 * Site-wide freshness signal. Answer engines (ChatGPT, Perplexity, Google AI
 * Overviews) weigh visible and machine-readable "last updated" dates when
 * deciding whether a page is worth citing. Bump this whenever site content
 * changes meaningfully.
 */
export const SITE_LAST_UPDATED = "2026-10-10";
